<a class="back-link" [routerLink]="link" queryParamsHandling="preserve" [mmTestTarget]="'back-link'">
    <span class="back-link__icon">
        <mm-icon *appHideFor="'mm-mobile'" name="arrow-left" type="fluid"></mm-icon>
        <mm-icon *appShowFor="'mm-mobile'" name="arrow-back-mobile" type="fluid"></mm-icon>
    </span>
    <span class="back-link__text">
        <ng-content></ng-content>
    </span>
</a>
